"use client";

import { useEffect } from "react";
import { logError } from "@/new_actions/errors/log_error";

/**
 * Mounts global window.onerror and unhandledrejection listeners.
 * Renders nothing — drop it once in the root layout.
 */
export function GlobalErrorHandler() {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      logError({
        message: event.message || "Unknown JS error",
        type: "js_error",
        source: window.location.pathname,
        stack: event.error?.stack,
      });
    };

    const handleRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      logError({
        message: reason?.message || String(reason) || "Unhandled promise rejection",
        type: "unhandled_rejection",
        source: window.location.pathname,
        stack: reason?.stack,
      });
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  return null;
}
